// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"495":"7823a231","783":"806133b0"}[chunkId] + ".chunk.css";
};